import type { STS } from 'aws-sdk';

let cachedStsCredentials: {
    credentials: STS.Credentials;
    expiresAt: Date;
} | null = null;

let pendingStsPromise: Promise<STS.Credentials> | null = null;

export const getCachedCredentials = () => cachedStsCredentials;

export const setCachedCredentials = (creds: STS.Credentials) => {
    cachedStsCredentials = {
        credentials: creds,
        expiresAt: new Date(creds.Expiration!)
    };
};

export const getPendingStsPromise = () => pendingStsPromise;

export const setPendingStsPromise = (p: Promise<STS.Credentials> | null) => {
    pendingStsPromise = p;
};
